import * as React from "react";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  SARIconThemeColor,
  setMobileButttonBackColor,
  setMobileTextColor,
} from "../../../utility";

const CheckModifier = (props) => {
  const index = props.values.modifiers.findIndex(
    (element) => element.id === props.modifier.group.id
  );

  return (
    <div className="d-flex justify-content-between align-items-center">
      <FormControlLabel
        value={JSON.stringify(props.order)}
        control={<Radio />}
        label={
          <span
            className="sub-font"
            style={{
              color:
                localStorage.getItem("theme") === "dark" ||
                localStorage.getItem("theme") === "white"
                  ? "#6BA5F2"
                  : setMobileButttonBackColor(),
            }}
          >
            {props.order.name}
          </span>
        }
        checked={props.values.modifiers[index]?.order_options.includes(
          props.order.id
        )}
      />

      {props.order.price && (
        <span
          className="head-font mx-2 font-size-16"
          style={{
            color:
              localStorage.getItem("theme") === "dark" ||
              localStorage.getItem("theme") === "white"
                ? "#6BA5F2"
                : setMobileButttonBackColor(),
          }}
        >
          {props.order.price} {props?.currency ? props?.currency === "SAR" ? <img width={20} height={20} src={SARIconThemeColor()}  className="mr-1" /> : props?.currency : ""}
        </span>
      )}
    </div>
  );
};

export default CheckModifier;
